import React, { useEffect, useState } from 'react';
import '../../common/css/reissueRequest.css';
import ReissuReservation from './reservationNumber/reissuReservation';
import axios from 'axios';
import Cookies from 'js-cookie';
import SaveModal from '../modal/saveModal';

function ReissueRequestPage() {
    const [modalAction, setModalAction] = useState(null);
    const [modalContent, setModalContent] = useState(null);
    const [saveStatus, setSaveStatus] = useState(true);
    const [isCheck, setIsCheck] = useState(true);
    const [regAgentName, setRegAgentName] = useState('');
    const [regAgentPhone, setRegAgentPhone] = useState('');
    const [reservations, setReservations] = useState([
        {
            air_pnr: '',
            tkt_number: '',
            org_flight: '',
            new_flight: '',
            tkt_email_address: '',
            freeMemo: '',
        },
    ]);

    useEffect(() => {
        const axiosData = async () => {
            try {
                const hostname = window.location.hostname;
                let isLocal = null;
                if (hostname === 'wpal.philippineair.co.kr') {
            isLocal = true;
        } else {
            isLocal = false;
        }

                const response = await axios.get(
                    `${
                        isLocal
                            ? process.env.REACT_APP_PRODUCTION_API_URL
                            : process.env.REACT_APP_LOCAL_API_URL
                    }/wpal/board/autoreissu/info`,
                    {
                        withCredentials: true,
                    },
                );
                setRegAgentName(response.data.userName);
                setRegAgentPhone(response.data.userPhone);
            } catch (error) {
                setModalContent(error?.response?.data?.message);
                setModalAction(() => () => (window.location.href = '/login'));
                setSaveStatus(false);            }
        };
        if (Cookies.get('isLogin')) {
            axiosData();
        } else {
            setModalContent('로그인 후 이용 가능한 서비스 입니다.');
            setModalAction(() => () => (window.location.href = '/login'));
            setSaveStatus(false);
        }
    }, []);

    const reservationAdd = () => {
        setReservations([
            ...reservations,
            {
                air_pnr: '',
                tkt_number: '',
                org_flight: '',
                new_flight: '',
                tkt_email_address: '',
                freeMemo: '',
            },
        ]);
    };

    // 예약 삭제
    const reservationRemove = () => {
        if (reservations.length > 1) {
            setReservations(reservations.slice(0, -1));
        }
    };

    // 입력 필드 변경 시 상태 업데이트
    const handleChange = (index, field, value) => {
        setReservations(
            reservations.map((reservation, i) =>
                i === index ? { ...reservation, [field]: value } : reservation,
            ),
        );
    };

    const handleSubmit = async () => {
        try {
            for (let i = 0; i < reservations.length; i++) {
                if (reservations[i].air_pnr === '') {
                    setModalContent('항공사 예약번호를 입력해주세요.');
                    setModalAction(() => () => setSaveStatus(true));
                    setSaveStatus(false);
                    return;
                } else if (reservations[i].tkt_number === '') {
                    setModalContent('탑승객명을 입력해주세요.');
                    setModalAction(() => () => setSaveStatus(true));
                    setSaveStatus(false);
                    return;
                } else if (reservations[i].org_flight === '') {
                    setModalContent('티켓번호를 입력해주세요.');
                    setModalAction(() => () => setSaveStatus(true));
                    setSaveStatus(false);
                    return;
                } else if (reservations[i].new_flight === '') {
                    setModalContent('요청 티켓번호를 입력해주세요.');
                    setModalAction(() => () => setSaveStatus(true));
                    setSaveStatus(false);
                    return;
                } else if (reservations[i].tkt_email_address === '') {
                    setModalContent('S/C 영향 편명 및 일자를 입력해주세요.');
                    setModalAction(() => () => setSaveStatus(true));
                    setSaveStatus(false);
                    return;
                }
            }

            const hostname = window.location.hostname;
            let isLocal = null;
            if (hostname === 'localhost' || hostname === 'twpal.philippineair.co.kr') {
                isLocal = false;
            } else {
                isLocal = true;
            }

            await axios.post(
                `${
                        isLocal
                            ? process.env.REACT_APP_PRODUCTION_API_URL
                            : process.env.REACT_APP_LOCAL_API_URL
                    }/wpal/board/autoreissu/request`,
                { reservations, isCheck },
                {
                    withCredentials: true,
                },
            );

            window.location.href = '/service/reissueList';

        } catch (error) {
            setModalContent(error.response.data.message);
            setModalAction(() => () => setSaveStatus(true));
            setSaveStatus(false);
        }
    };

    return (
        <div id='contents' className='contents'>
            <div class='subp_h_wrap'>
                <div class='subp_h_list subp_h_home'>
                    <div>서비스요청</div>
                    <div>AUTO REISSUE - SC 티켓 VOID 요청</div>
                    <div>요청하기</div>
                </div>
            </div>
            <div className='page_hgroup'>
                <h2 className='title'>AUTO REISSUE - SC 티켓 VOID 요청</h2>
            </div>
            <div className='table_wrap mb40'>
                <table
                    className='table_style4 bdt mb70'
                    cellPadding='0'
                    cellSpacing='0'
                    id='airCertInfoTbl'
                >
                    <colgroup>
                        <col style={{ width: '190px' }} />
                    </colgroup>
                    <tbody>
                        <tr>
                            <th>
                                <p className='essential'>담당자</p>
                            </th>
                            <td colSpan='3'>{regAgentName}</td>
                        </tr>
                        <tr>
                            <th>
                                <p className='essential'>휴대폰 번호</p>
                            </th>
                            <td colSpan='3'>
                                {regAgentPhone}
                                <label name='agreeSendSNS'>
                                    <input
                                        type='checkbox'
                                        name='agreeSendSNS'
                                        id='agreeSendSNS'
                                        className='agreeSendSNSInput'
                                        checked={isCheck}
                                        onClick={() => setIsCheck(!isCheck)}
                                    />
                                    답변등록 시 SMS 전송
                                </label>
                                <a className='editPhoneNum' href='/mypage'>
                                    (&nbsp;&nbsp;<i class='fa-solid fa-mobile-screen-button'></i>
                                    &nbsp;&nbsp;담당자 휴대폰번호 수정&nbsp;&nbsp;)
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div className='btn_area reissue_area'>
                    <input
                        type='button'
                        id='plusPnrNum'
                        value='+ 예약번호 추가'
                        className='btn36 red sendAuthNumY mo-mt-btn'
                        style={{ height: '45px', lineHeight: 'unset' }}
                        onClick={reservationAdd}
                    />
                    <input
                        type='button'
                        id='minPnrNum'
                        value='- 예약번호 삭제'
                        className='btn36 red sendAuthNumY mo-mt-btn'
                        style={{ height: '45px', lineHeight: 'unset' }}
                        onClick={reservationRemove}
                    />
                </div>
                {reservations.map((data, index) => (
                    <ReissuReservation
                        num={index}
                        data={data}
                        key={index}
                        handleChange={handleChange}
                    />
                ))}
            </div>
            <div className='btn_area'>
                <input
                    type='button'
                    id='sendRequest'
                    value='VOID 요청하기'
                    className='btn46 blue'
                    onClick={handleSubmit}
                    style={{ width: '260px' }}
                />
            </div>
            <div class='title_wrap mt70' style={{ justifyContent: 'flex-start' }}>
                <h4>유의 사항</h4>
            </div>
            <table class='table_style3 bdt' cellpadding='0' cellspacing='0' id='privateInfoTbl'>
                <colgroup>
                    <col style={{ width: '100%' }} />
                </colgroup>
                <tbody>
                    <tr>
                        {/*prettier-ignore */}
                        <td className='infoTable' style={{padding:'10px'}}>
                            <strong className='fontWeight'>※ 요청 시, 본사를 통해 VOID 처리가 진행되며, 영업일 기준 1~2일 이내에 완료됩니다. 단, 현지 휴무일 등 일정에 따라 추가 시간이 소요될 수 있습니다.</strong><br />
                            <br />
                            <strong>1. 비운항 또는 일정 변경(Schedule Change)로 인해 PAL에서 자동 재발행(AUTO-REISSUE)된 티켓에 한하여 VOID 요청이 가능합니다.</strong><br />
                            <strong>2. PAL에 의해 재발행된 티켓 VOID 처리 외의 요청 건은 접수되지 않습니다.</strong><br />
                            <strong>3. <span className='red' id='point' >[중요]</span> 재발행 티켓 VOID 처리 이후, INVOL SC로 인한 일정 변경 또는 환불 요청은 여행사에서 'Schedule Change 발생 시 BSP INVOL 재발행 허용 범주 및 처리 지침'을</strong><br />
                            <span class="ml10"> 확인한 후 진행해 주시기 바랍니다.</span>
                        </td>
                    </tr>
                </tbody>
            </table>
            <SaveModal content={modalContent} SaveBtn={saveStatus} onClose={modalAction} />
        </div>
    );
}

export default ReissueRequestPage;
